import { AxiosResponse } from 'axios'
import {
  CencusApiActivityDataResponseDto,
  CencusApiActivityDataType,
  CencusApiActivityFormattedDataType,
  CensusQueryParams,
} from './types'
import client from 'enrollment-platform/api/eps.client'
import { PaginationResponse } from 'enrollment-platform/types/pagination-response-dto'

const HRIS_SYNC_CENSUS_ENDPOINT = '/api/v1/hris-sync-census'

export const getHrisSyncCensusData = async (
  params: CensusQueryParams
): Promise<CencusApiActivityFormattedDataType> => {
  const queryParams: CensusQueryParams = {
    page: params.page,
    limit: params.limit,
    clientPublicKey: params.clientPublicKey,
  }

  const response: AxiosResponse<
    PaginationResponse<CencusApiActivityDataResponseDto>
  > = await client.get(HRIS_SYNC_CENSUS_ENDPOINT, {
    params: queryParams,
  })

  const formatData: CencusApiActivityDataType[] = response.data.data.map(
    (item: CencusApiActivityDataResponseDto) => {
      return {
        customer: item.clientCompanyName,
        timeReceived: item.uploadedAt,
        timeProcessed: item.processedAt,
        originalData: item.personCount,
        originalDataUrl: item.originalFileUrl,
        processedData: item.personSyncedCount,
        processedDataUrl: item.processedFileUrl,
        status: item.status,
        id: item.id,
        description: item.description,
      }
    }
  )

  return { data: formatData, meta: response.data.meta }
}
